import { UltrabufCodec } from '@tencent/slide-sdk-pb-model/src/codec';
import { type UltrabufTypeMap } from '@tencent/slide-sdk-pb-model';
import { Base64String } from '../utils/base64-utils';
import type { UltrabufDecodeProcessor, UltrabufEncodeProcessor } from '@tencent/slide-sdk-pb-model/src/codec';

export class SlideCodec extends UltrabufCodec {
    public static codec = new SlideCodec();
    public processors: {
        encode?: UltrabufEncodeProcessor;
        decode?: UltrabufDecodeProcessor;
    } = {};

    public override decode<TypeIndex extends keyof UltrabufTypeMap>(
        bufferOrBase64: string | Uint8Array,
        typeIndex: TypeIndex,
    ) {
        return super.decode(
            Base64String.toUint8Array(bufferOrBase64),
            typeIndex,
            (message: any, fieldName: string, value: any) => {
                // 解码如果以 _i 结尾（驼峰即I），则转换原始字段为 null
                if (fieldName.endsWith('I') && value === true) {
                    message[fieldName.slice(0, -1)] = null;
                }
                this.processors.decode?.(message, fieldName, value);
            },
        );
    }

    public override encode<TypeIndex extends keyof UltrabufTypeMap>(
        message: UltrabufTypeMap[TypeIndex],
        typeIndex: TypeIndex,
    ): Uint8Array {
        return super.encode(message, typeIndex, (message: any, fieldName: string, value: any) => {
            // 预处理 null，转化为 _i 的形式（数据中台约定，表示删除该字段）
            if (value === null) {
                message[`${fieldName}I`] = true;
            }

            this.processors.encode?.(message, fieldName, value);
        });
    }
}
